import { useEffect } from "react";

/**
 * Listener global de `Ctrl+K` / `Cmd+K` · llama al callback cuando se
 * dispara. El callback típicamente toggles el estado abierto/cerrado
 * de la paleta. Esc no se maneja acá porque Mantine Modal ya lo cubre.
 */
export function useCommandPaletteShortcut(onToggle: () => void) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const isCmdK = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k";
      if (isCmdK) {
        e.preventDefault();
        onToggle();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onToggle]);
}
